import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sendMessageToAdmin } from '../../../actions/chat'
import { useNavigate } from 'react-router'
import { getCompanyDashboardAction } from '../../../actions/companyDashboard'
import CompanyAccountDetails from './components/companyAccountDetails'
import CompanyBullionBalance from './components/compnayBullionBalance'
import CompanyMetalAllocation from './components/companyMetalAllocation'
import CompanyProfileLoss from './components/companyProfileLoss'
import CompanyCashBalance from './components/companyCashBalance'
import { sendMessageToAdminChat } from '../../../actions/chatv2'
import { SET_HAS_FETCHED_BID_PRICES_USER } from '../../../actions/types'


export default function BuillionAccountCompany() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isEditing, setIsEditing] = useState(null);
    const [adminLoader, setAdminLoader] = useState(null);
    const { selectedCompany } = useSelector((state) => state.company);
    const { hasFetchedUser } = useSelector((state) => state.user);

    useEffect(() => {
        let id = selectedCompany?.id
        if (id) {
            if (!hasFetchedUser) {
                dispatch(getCompanyDashboardAction(id));
                dispatch({ type: SET_HAS_FETCHED_BID_PRICES_USER, payload: true });
            }
        }
    }, [dispatch, selectedCompany])

    useEffect(() => {
        setAdminLoader(null);
    }, [])



    const sendMessageToAdminfunc = async (type, message, loaderType) => {
        setAdminLoader(loaderType)
        await sendMessageToAdminChat(message, null, type, navigate, []);
    }


    return (
        <>
            {/* {isBrowser && <AddDashboard />} */}
            <CompanyAccountDetails isEditing={isEditing} setIsEditing={(value) => setIsEditing(value)} />
            {/* {isMobile
             && <AddDashboard />} */}
            <div className='row'>

                <div className='col-md-6'>
                    <CompanyBullionBalance isEditing={isEditing} setIsEditing={(value) => setIsEditing(value)} sendMessageToAdmin={sendMessageToAdminfunc} adminLoader={adminLoader} />
                </div>

                <div className='col-md-6'>
                    <CompanyMetalAllocation isEditing={isEditing} setIsEditing={(value) => setIsEditing(value)} />
                </div>
                <div className='col-md-6'>
                    <CompanyCashBalance isEditing={isEditing} setIsEditing={(value) => setIsEditing(value)} sendMessageToAdmin={sendMessageToAdminfunc} adminLoader={adminLoader} />
                </div>
                {/* <div className='col-md-6'>
                    <CompnayProductAllocation isEditing={isEditing} setIsEditing={(value) => setIsEditing(value)} />
                </div> */}

                <div className='col-md-6'>
                    <CompanyProfileLoss isEditing={isEditing} setIsEditing={(value) => setIsEditing(value)} />
                </div>
                {/* <div className='col-md-6'>
                    <AllInvites sendMessageToAdmin={sendMessageToAdminfunc} adminLoader={adminLoader} />
                </div> */}
            </div>
        </>
    )
}
